import React from 'react';

import { Tabs, TabsList, TabsTrigger } from '@mesh.ai/rabbit';
import { matchPath, useHistory, useLocation } from 'react-router-dom';

const PageTabbedNavigationV1 = ({ tabs }) => {
  const history = useHistory();
  const location = useLocation();

  // to match dynamic named routes
  const pathname = tabs.find((tab) => {
    const isMatch = matchPath(location.pathname, {
      path: tab.value,
    });
    return isMatch;
  })?.value;

  return (
    <Tabs value={pathname} onValueChange={(value) => history.push(value)}>
      <TabsList>
        {tabs.map((tab) => {
          if (tab.hideFromTabList) {
            return null;
          }
          return (
            <TabsTrigger key={tab.value} value={tab.value}>
              {tab.label}
            </TabsTrigger>
          );
        })}
      </TabsList>
    </Tabs>
  );
};

export { PageTabbedNavigationV1 };
